import {
    PRODUCT_DELETE_PRO_LNGLIST_BEGIN,
    PRODUCT_DELETE_PRO_LNGLIST_SUCCESS,
    PRODUCT_DELETE_PRO_LNGLIST_FAILURE,
    PRODUCT_DELETE_PRO_LNGLIST_DISMISS_ERROR,
  } from './constants';
  
  import request from '../../../utils/request'
  // Rekit uses redux-thunk for async actions by default: https://github.com/gaearon/redux-thunk
  // If you prefer redux-saga, you can use rekit-plugin-redux-saga: https://github.com/supnate/rekit-plugin-redux-saga
  export function deletePro_lnglist(id) {
    return (dispatch) => { // optionally you can have getState as the second argument
      dispatch({
        type: PRODUCT_DELETE_PRO_LNGLIST_BEGIN,
      });
  
      // Return a promise so that you could control UI flow without states in the store.
      // For example: after submit a form, you need to redirect the page to another when succeeds or show some errors message if fails.
      // It's hard to use state to manage it, but returning a promise allows you to easily achieve it.
      // e.g.: handleSubmit() { this.props.actions.submitForm(data).then(()=> {}).catch(() => {}); }
      const promise = new Promise((resolve, reject) => {
          request({
            method:'DELETE',
            url:`/api/gc/product/lng/${id}`,
          }).then( data => {
              dispatch({
                  type: PRODUCT_DELETE_PRO_LNGLIST_SUCCESS,
              });
              resolve(data);
          }).catch (error => {
              dispatch({
                type: PRODUCT_DELETE_PRO_LNGLIST_FAILURE,
                data: { error: error },
              });
              reject(error);
          })
      });
  
      return promise;
    };
  }
  
  // Async action saves request error by default, this method is used to dismiss the error info.
  // If you don't want errors to be saved in Redux store, just ignore this method.
  export function dismissDeletePro_lnglistError() {
    return {
      type: PRODUCT_DELETE_PRO_LNGLIST_DISMISS_ERROR,
    };
  }
  
  export function reducer(state, action) {
    switch (action.type) {
      case PRODUCT_DELETE_PRO_LNGLIST_BEGIN:
        // Just after a request is sent
        return {
          ...state,
          deletePro_lnglistPending: true,
          deletePro_lnglistError: null,
        };
  
      case PRODUCT_DELETE_PRO_LNGLIST_SUCCESS:
        // The request is success
        return {
          ...state,
          deletePro_lnglistPending: false,
          deletePro_lnglistError: null,
        };
  
      case PRODUCT_DELETE_PRO_LNGLIST_FAILURE:
        // The request is failed
        return {
          ...state,
          deletePro_lnglistPending: false,
          deletePro_lnglistError: action.data.error,
        };
  
      case PRODUCT_DELETE_PRO_LNGLIST_DISMISS_ERROR:
        // Dismiss the request failure error
        return {
          ...state,
          deletePro_lnglistError: null,
        };
  
      default:
        return state;
    }
  }
  


// WEBPACK FOOTER //
// ./src/features/product/redux/deletePro_lnglist.js